<template>
    <div class="background">
        <a-icon
            v-if="backPath !== ''"
            v-on:click="returnHome"
            class="back-button"
            type="left-circle" />
        <slot></slot>
    </div>
</template>

<script>
 export default {
     name: 'Background',
     data() {
         return {
         }
     },
     props: {
         backPath: {
             type: String,
             default: function () {
                 return ""
             }
         },
     },
     components: {
     },
     methods: {
         returnHome() {
             if (this.backPath == "prevPage") {
                 this.$router.go(-1)
             } else {
                 this.$router.replace(this.backPath)
             }
         },
     },
 }
</script>

<style scoped>
 .background {
     flex-direction: column;
     align-items: center;
     justify-content: center;
     display: flex;
     width: 100%;
     height: 100%;
     background-image: url("https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/background.jpg");
     background-repeat: no-repeat;
     background-size: 100% 100%;

     position: relative;
 }

 .back-button {
     position: absolute;
     top: 20px;
     left: 20px;
     color: #BBB;
     font-size: 40px;
     cursor: pointer;
     z-index: 1000;
 }

 .back-button:hover {
     color: #666;
 }

 .return-button:hover {
     color: #666;
 }
</style>
